
import { soldVehiclesCount } from '../../../mocks/donationData';

export default function OregonDogRescuePartnershipBanner() {
  const totalDonated = soldVehiclesCount * 100;

  return (
    <section className="py-16 bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100 relative overflow-hidden">
      {/* Decorative paw prints */}
      <div className="absolute top-8 left-12 text-amber-300/30 text-4xl">
        <i className="ri-footprint-fill"></i>
      </div>
      <div className="absolute top-20 right-20 text-orange-300/30 text-3xl">
        <i className="ri-footprint-fill"></i>
      </div>
      <div className="absolute bottom-12 left-1/4 text-amber-300/30 text-2xl">
        <i className="ri-footprint-fill"></i>
      </div>
      <div className="absolute bottom-20 right-1/3 text-orange-300/30 text-3xl">
        <i className="ri-footprint-fill"></i>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-amber-200">
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Left Side - Partnership Info */}
            <div className="p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-100 border-2 border-amber-300 rounded-full mb-6 w-fit">
                <i className="ri-heart-fill text-red-500"></i>
                <span className="text-sm font-bold text-gray-800 uppercase tracking-wide">
                  Official Partnership
                </span>
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                Every Sale Saves Lives
              </h2>
              
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                We're proud partners with <strong>Oregon Dog Rescue</strong>, a no-kill shelter serving the greater Portland, Oregon area devoted to placing dogs in the best homes and assuring the long-term success of the adoption.
              </p>

              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-6 mb-6 border-2 border-teal-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                    <i className="ri-hand-coin-fill text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-teal-900 mb-1">
                      $100 Per Vehicle
                    </p>
                    <p className="text-sm text-teal-800">
                      For every vehicle we sell, we donate $100 directly to Oregon Dog Rescue
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-6 mb-6">
                <div className="text-center">
                  <p className="text-4xl font-bold text-amber-600">{soldVehiclesCount}+</p>
                  <p className="text-sm text-gray-600 font-medium">Vehicles Sold</p>
                </div>
                <div className="w-px h-12 bg-gray-300" />
                <div className="text-center">
                  <p className="text-4xl font-bold text-green-600">${totalDonated.toLocaleString()}</p>
                  <p className="text-sm text-gray-600 font-medium">Total Donated</p>
                </div>
                <div className="w-px h-12 bg-gray-300" />
                <div className="text-center">
                  <p className="text-4xl font-bold text-red-500">300+</p>
                  <p className="text-sm text-gray-600 font-medium">Dogs Rescued</p>
                </div>
              </div>

              <a
                href="https://www.oregondogrescue.org"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 bg-amber-500 text-white font-bold rounded-full hover:bg-amber-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-fit"
              >
                <i className="ri-external-link-line mr-2"></i>
                Visit Oregon Dog Rescue
              </a>
            </div>

            {/* Right Side - Visual */}
            <div className="relative bg-gradient-to-br from-amber-400 via-orange-400 to-amber-500 p-8 sm:p-10 lg:p-12 flex flex-col items-center justify-center">
              <div className="absolute top-6 left-6 text-white/20 text-5xl">
                <i className="ri-footprint-fill"></i>
              </div>
              <div className="absolute bottom-6 right-6 text-white/20 text-5xl">
                <i className="ri-footprint-fill"></i>
              </div>

              <div className="relative z-10 text-center">
                <div className="w-32 h-32 flex items-center justify-center bg-white rounded-full mb-6 mx-auto shadow-2xl">
                  <i className="ri-heart-pulse-fill text-6xl text-red-500"></i>
                </div>

                <h3 className="text-3xl font-bold text-white mb-4 drop-shadow-lg">
                  Oregon Dog Rescue
                </h3>
                
                <p className="text-white/95 text-lg mb-6 max-w-md mx-auto leading-relaxed drop-shadow">
                  A no-kill shelter serving the greater Portland, Oregon area. Started in 2007, devoted to placing dogs in the best homes and assuring the long-term success of every adoption.
                </p>

                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 border-2 border-white/40">
                  <p className="text-white font-bold text-xl mb-2">
                    "Your Next Best Friend is Waiting"
                  </p>
                  <p className="text-white/90 text-sm italic">
                    Together, we're making a difference one vehicle—and one rescue—at a time.
                  </p>
                </div>

                <div className="flex items-center justify-center gap-4 mt-8 text-white/40 text-4xl">
                  <i className="ri-footprint-fill"></i>
                  <i className="ri-heart-fill text-red-300"></i>
                  <i className="ri-footprint-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom tagline */}
        <div className="text-center mt-8">
          <p className="text-gray-700 text-lg font-medium">
            <i className="ri-car-fill text-teal-600 mr-2"></i>
            Buy a car. Save a life. Support your community.
            <i className="ri-heart-fill text-red-500 ml-2"></i>
          </p>
        </div>
      </div>
    </section>
  );
}
